import {
  OnboardingRoutesPublic,
  CheckoutRoutesPublic,
  CrossSellerRoutesPublic,
} from '@shared/modules';
import { Navigate, createBrowserRouter } from 'react-router-dom';

export const PublicRoutes = createBrowserRouter([
  ...CheckoutRoutesPublic(),
  ...OnboardingRoutesPublic(),
  ...CrossSellerRoutesPublic(),
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
